import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4d0d60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MBotoesRodape",
  "data-testid": "MBotoesRodape"
}

import PButton from "primevue/button"
  import { useI18n } from "vue-i18n"

  interface Props {
    carregando?: boolean
    desabilitado?: boolean
    rotuloBotaoConfirmar?: string
    rotuloBotaoNegar?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MBotoesRodape',
  props: {
    carregando: { type: Boolean },
    desabilitado: { type: Boolean },
    rotuloBotaoConfirmar: { default: "" },
    rotuloBotaoNegar: { default: "" }
  },
  emits: ["salvar", "cancelar"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "salvar"): void
    (event: "cancelar"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { carregando?: boolean, desabilitado?: boolean, rotuloBotaoConfirmar: string, rotuloBotaoNegar: string }

  const { t } = useI18n()

  

  const rotuloBotaoConfirmar = props.rotuloBotaoConfirmar || t("salvar")
  const rotuloBotaoNegar = props.rotuloBotaoNegar || t("cancelar")

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PButton), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emitir('salvar'))),
      class: "MBotoesRodape__Botao p-button-success",
      "data-testid": "MBotoesRodape__Salvar",
      disabled: __props.desabilitado || __props.carregando,
      label: _unref(rotuloBotaoConfirmar),
      loading: __props.carregando
    }, null, 8, ["disabled", "label", "loading"]),
    _createVNode(_unref(PButton), {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emitir('cancelar'))),
      class: "MBotoesRodape__Botao p-button-danger",
      "data-testid": "MBotoesRodape__Cancelar",
      disabled: __props.carregando,
      label: _unref(rotuloBotaoNegar)
    }, null, 8, ["disabled", "label"])
  ]))
}
}

})